<template>
    <div>
        <table-list
            ref="table"
            idKey="carId"
            :searchConfig="searchConfig"
            :listConfig="listConfig"
            :apis="apis"
            :createFrom="fromConfig"
            :btn-config="btnConfig"
            @handleBtn="handleBtn"
            :btnConfig="btnConfig | filterBtnsRole($route)"
        />
        <from-list ref="blacklist" :fromConfig="blackConfig" @confirm="blackConfirm"></from-list>
        <from-list ref="auditlist" :fromConfig="auditConfig" @confirm="auditConfirm"></from-list>
    </div>
</template>

<script>
import config from './config/Car.config'
import {auditCar, carAddBlacklist} from '@/api/car'
export default {
    data() {
        return {
            blackConfig: [],
            auditConfig: [],
            ...config()
        }
    },
    methods: {
        handleBtn(key, list) {
            if (key === 'blacklist') {
                if (list.length !== 1) this.$error('请选择一项加入黑名单')
                this.blackConfig = this.createBlack();
              this.$refs[key].open(null, { id: list[0].carId })
            } else if (key === 'auditlist') {

              if (list.length !== 1) this.$error('请选择一项进行审核')
              if (list.filter(item => item.auditState !== 3).length>0) this.$error('请选择认证中的数据')
              this.auditConfig = this.createAudit();
              let tmp = list[0]
              let row = {
                carNo:tmp.carNo,
                powerType:tmp.powerType,
                boxType:tmp.boxType,
                carType:tmp.carType,
                axleNumName:tmp.axleNumName,
                drivingPermitFull:tmp.drivingPermitFull,
                drivingPermitBack:tmp.drivingPermitBack,
                carFull:tmp.carFull,
                permitFull:tmp.permitFull,
                carInsurancePhoto:tmp.carInsurancePhoto,
                //挂车
                carGno:tmp.carGno,
                gAxleNum:tmp.gAxleNum,
                gAxleNumName:tmp.gAxleNumName,
                trailerFull:tmp.trailerFull,
                trailerBack:tmp.trailerBack,
              }
              this.$refs[key].open(row, { id: tmp.carId })
            }

        },
        async blackConfirm(data) {
            const params = this.$params(this.blackConfig);
            const [res] = await this.$ajax(carAddBlacklist, {...params, ...data});
            if (res) {
                this.$refs.blacklist.close();
                this.$refs.table.getList();
            }
        },
        async auditConfirm(data) {
          const params = this.$params(this.auditConfig);
          const [res] = await this.$ajax(auditCar, {...params, ...data});
          if (res) {
            this.$refs.auditlist.close();
            this.$refs.table.getList();
          }
        }
    }
}
</script>

<style lang="less" scoped>

</style>
